module.exports = __webpack_public_path__ + "b176de4c6f8bfbf975838e3b1a470424.png";